<template>
    <div style="position: relative;">
        <el-row :gutter="20">
            <el-col :xm="24" :md="12" :lg="14" style="margin-bottom:30px;">
                <div class="biaoqian">在线视频制作</div>
                <el-card class="box-card" style="border-radius:10px;" shadow="never">
                    <div style="font-size: 14px;">
                        <qhyupload ref="qhyupload" :limit_url="1"></qhyupload>
                    </div>
                    <div style="margin-top:30px;">
                        <el-button @click="ks()" style="width:100%;background-color: #484add;border-color: #484add;"
                            type="success">框选字幕位置</el-button>
                    </div>
                </el-card>
            </el-col>

            <el-col :xm="24" :md="12" :lg="10">
                <div style="display: flex;flex-direction: column">

                    <div class="biaoqian">制作记录</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <div style="font-size: 14px;">
                            <!-- <div style="margin:10px 0px;">制作记录</div> -->
                            <Record ref="record"></Record>
                        </div>

                    </el-card>
                </div>
            </el-col>
        </el-row>
        <div v-show="show_qzm"
            style="position: fixed;top: 8%;right: 0;left: 0;bottom:0;z-index: 999;display: flex;justify-content: center;">
            <div style="position: relative;width: 50%;min-width: 350px;height: 75vh;
                        border: 5px solid #67c23a;">
                <div @click="close_qzm()"
                    style="position: absolute;top: -10px;right: -10px;cursor: pointer;z-index: 99;">
                    <i class="el-icon-error" style="font-size: 3vh;padding-left: 5px;color: #ff1136;"></i>
                </div>
                <Qzmview ref="qzmview" @showstatus="close_qzm()"></Qzmview>
            </div>

        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Record from "./Record.vue";
import Balance from './Balance.vue';
import Dingzhi from "./Dingzhi.vue";
import Qzmview from "./Qzm.vue";
import COS from "cos-js-sdk-v5";

export default {
    name: '',
    components: {
        Record,
        Balance,
        Dingzhi,
        Qzmview,
    },
    // 定义属性
    data() {
        return {
            show_qzm: false
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ks() {
            var urls = this.$refs.qhyupload.get_urls()
            if (urls.status == 100) {
                return this.$msg.error(urls.msg)
            }
            console.log(urls)
            this.show_qzm = true
            this.$refs.qzmview.createurl(urls)
        },
        close_qzm() {
            try {
                this.$refs.qzmview.pause()
                this.$refs.qzmview.selectBoxList = []
            } catch (error) {

            }
            this.$refs.qhyupload.url_list = []
            this.show_qzm = false
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.upload2 .el-upload {
    width: 100%;
}

.upload2 .el-upload-dragger {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Qzmwin.vue


// WEBPACK FOOTER //
// src/components/User/Qzmwin.vue